import React, { useMemo } from 'react'
import {
  CardModalView,
  ViewBody,
} from 'components/Sidebar'
import BoardBlockers from 'routes/Board/Blockers'
import { FormattedMessage } from 'react-intl'
import Alert from 'components/Alert'
import {
  FormGroup,
  ControlLabel
} from 'react-bootstrap'
import blockerType, { BlockerType } from 'const/blockerType'
import BlockerListItem from 'components/BlockerListItem'

const BLOCKER_TYPES: {
  ids: BlockerType[];
  formattedMessageId: string;
}[] = [
  {
    ids: [blockerType.GLOBAL, blockerType.ON_DEMAND],
    formattedMessageId: 'BLOCKERS_GLOBAL',
  },
  {
    ids: [blockerType.LOCAL],
    formattedMessageId: 'BLOCKERS_LOCAL',
  },
]

const BlockersByType: React.FC<{
  blockers: any[];
  onSelect: (blockerId: number) => void;
}> = ({
  blockers,
  onSelect,
}) => {

  const blockerGroups = useMemo(() => {
    const blockerGroups: any[] = []

    BLOCKER_TYPES.forEach((_, index) => blockerGroups[index] = [])

    blockers.forEach(blocker => {
      const index = BLOCKER_TYPES.findIndex(BLOCKER_TYPE => BLOCKER_TYPE.ids.includes(blocker.type))

      if (index >= 0) {
        blockerGroups[index].push(blocker)
      }
    })

    blockerGroups.forEach(blockerGroup => blockerGroup.sort((a, b) => {
      const textA = a.name.toLowerCase()
      const textB = b.name.toLowerCase()

      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
    }))

    return blockerGroups
    }, [blockers]
  )

  return (
    <>
      {BLOCKER_TYPES.map((BLOCKER_TYPE, index) =>
        <FormGroup
          key={index}
        >
          <ViewBody>
            <ControlLabel>
              <FormattedMessage id={BLOCKER_TYPE.formattedMessageId} />
            </ControlLabel>
          </ViewBody>
          <ul className='list-group'>
            {blockerGroups[index].map(blocker =>
              <BlockerListItem
                key={blocker.id}
                name={blocker.name}
                description={blocker.description}
                onClick={() => {
                  onSelect(blocker.id)
                }}
              />
            )}
          </ul>
        </FormGroup>
      )}
    </>
  )
}

type Props =  {
  onSelect: (blockerId: number) => void
}

const SelectBlocker: React.FC<Props> = ({
  onSelect,
}) => {
  return (
    <CardModalView
      title={<FormattedMessage id='BLOCKERS_CARD_BLOCK_BLOCKER_SELECT' />}
    >
      <BoardBlockers>
        {blockers =>
          <ul className='list-group'>
            {blockers.length > 0 ? (
              <BlockersByType
                blockers={blockers}
                onSelect={onSelect}
              />
            ) : (
              <ViewBody>
                <Alert>
                  <FormattedMessage id='BLOCKERS_CARD_BLOCK_BLOCKER_SELECT_EMPTY' />
                </Alert>
              </ViewBody>
            )}
          </ul>
        }
      </BoardBlockers>
    </CardModalView>
  )
}

export default SelectBlocker
